import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue';

import {
  LoaderIndicator,
  HelperViewStatus,
  InitialAvatarIcon,
  BaseText,
  ButtonTertiary
} from '@warrenbrasil/nebraska-web';
import { ConcludedOrders, Filters, OpenedOrders } from './components';

import { EOrdersType } from './components/Filters/types';
import {
  getConcludedOrders,
  getOpenedOrders,
  IOrderItem,
  IOrderGroup
} from '@/modules/wealth/services/portfolio-orders';
import { registerObserver } from '@/modules/common/helpers/register-observer/register-observer';

interface Props {
  portfolioId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Orders',
  props: {
    portfolioId: null
  },
  emits: ["changeTabOpenOrders"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeTabOpenOrders', value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  portfolioId: string;
};





const isLoading = ref(false);
const isFiltering = ref(false);
const isScrolling = ref(false);
const hasError = ref(false);
const selectedTab = ref(EOrdersType.CONCLUDED);
const hasNextPage = ref(false);
const concludedOrders = ref<IOrderGroup[]>([]);
const openedOrders = ref<IOrderItem[]>([]);
const openedOrdersCount = ref(0);
const concludedParams = ref({
  page: 1,
  pageSize: 5
});
const filters = ref();
const periodFilter = ref();
const isFiltered = ref(false);
const showClearFilters = ref(false);

const disableFilters = computed(() => {
  return (
    isFiltering.value ||
    (concludedOrders.value.length === 0 && !isFiltered.value)
  );
});

const emptyState = computed(() => {
  return isFiltered.value
    ? {
        icon: 'EE0050',
        description: 'Não encontramos resultados para os filtros aplicados.',
        button: 'Limpar filtros'
      }
    : {
        icon: 'ED0080',
        description: 'Você ainda não possui ordens concluídas.',
        button: ''
      };
});

function handleChangeTab(value: EOrdersType) {
  selectedTab.value = value;

  if (value === EOrdersType.CONCLUDED) {
    setTimeout(() => {
      registerObserver(fetchMoreConcludedOrders, 'order-row');
    });
  }
}

async function handleChangeFilter(
  newParams: Record<string, string | string[]>,
  hasFilters: boolean
) {
  showClearFilters.value = false;
  isFiltered.value = hasFilters;

  concludedParams.value = {
    ...concludedParams.value,
    ...newParams
  };

  await fetchConcludedOrders();
  registerObserver(fetchMoreConcludedOrders, 'order-row');
}

function handleClearFilters() {
  showClearFilters.value = true;
}

function groupingList(newList: IOrderGroup[]) {
  const groupedList = new Map();

  concludedOrders.value.forEach(item => {
    groupedList.set(item.date, item);
  });

  newList.forEach(group => {
    if (groupedList.has(group.date)) {
      groupedList.get(group.date).items.push(...group.items);
    } else {
      groupedList.set(group.date, group);
    }
  });

  concludedOrders.value = Array.from(groupedList.values());
}

async function fetchMoreConcludedOrders() {
  isScrolling.value = true;

  try {
    if (!hasNextPage.value) return;

    concludedParams.value.page += 1;
    const data = await getConcludedOrders(
      props.portfolioId,
      concludedParams.value
    );

    hasNextPage.value = data.hasNextPage;
    groupingList(data.orders);

    return data.hasNextPage;
  } finally {
    isScrolling.value = false;
  }
}

async function fetchConcludedOrders() {
  isFiltering.value = true;

  try {
    concludedParams.value.page = 1;
    const data = await getConcludedOrders(
      props.portfolioId,
      concludedParams.value
    );

    hasNextPage.value = data.hasNextPage;
    concludedOrders.value = data.orders;
  } finally {
    isFiltering.value = false;
  }
}

async function fetchOrders() {
  isLoading.value = true;
  hasError.value = false;

  try {
    const [concluded, opened] = await Promise.all([
      getConcludedOrders(props.portfolioId, concludedParams.value),
      getOpenedOrders(props.portfolioId)
    ]);

    hasNextPage.value = concluded.hasNextPage;
    concludedOrders.value = concluded.orders;
    filters.value = concluded.filters;
    periodFilter.value = concluded.periodFilter;

    openedOrders.value = opened.orders;
    openedOrdersCount.value = opened.count;

    emit('changeTabOpenOrders', opened.count || 0);

    if (openedOrdersCount.value > 0) {
      selectedTab.value = EOrdersType.OPENED;
    }
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(async () => {
  await fetchOrders();

  if (hasNextPage.value) {
    registerObserver(fetchMoreConcludedOrders, 'order-row');
  }
});

return { __sfc: true,props, emit, isLoading, isFiltering, isScrolling, hasError, selectedTab, hasNextPage, concludedOrders, openedOrders, openedOrdersCount, concludedParams, filters, periodFilter, isFiltered, showClearFilters, disableFilters, emptyState, handleChangeTab, handleChangeFilter, handleClearFilters, groupingList, fetchMoreConcludedOrders, fetchConcludedOrders, fetchOrders, LoaderIndicator, HelperViewStatus, InitialAvatarIcon, BaseText, ButtonTertiary, ConcludedOrders, Filters, OpenedOrders, EOrdersType }
}

})